<template>
  <div class="track-order-page">
    <Breadcrumb></Breadcrumb>
     <QrTableOrderStatus v-if="isFloorTableAvailable && isFloorTableAvailable.table_id"></QrTableOrderStatus>
    <TrackOrder v-else></TrackOrder>
    <Review></Review>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '../Blocks/Order/Breadcrumb'
import QrTableOrderStatus from '../Blocks/Order/QrTableOrderStatus'
import TrackOrder from '../Blocks/Order'
import Review from '../Blocks/Review/Review'
export default {
  components: {
    Breadcrumb,
    TrackOrder,
    Review,
    QrTableOrderStatus,
  },
  computed: {
    ...mapGetters(['_T','isFloorTableAvailable']),
  },
  updated() {
    this.$store.commit('CLEAR_CART')
    this.$store.commit('CLEAR_CHECKOUT')
  },
  beforeRouteEnter(to, from, next) {
    document.body.style.setProperty('overflow', 'hidden')
    next()
  },
  beforeRouteLeave(to, from, next) {
    document.body.style.removeProperty('overflow')
    document.body.style.setProperty('overflow-x', 'hidden')
    next()
  },
}
</script>

<style lang="scss" scoped>
.track-order-page {
  overflow: auto;
  @media (max-width: 575px) {
    height: 100vh;
  }
}
</style>
